import { useCallback } from 'react'
import styled from 'styled-components'
import { rem } from 'polished'

import SegmentedOption from 'LuxKit/SegmentedOptions/SegmentedOption'
import SegmentedOptionsGroup from 'LuxKit/SegmentedOptions/SegmentedOptionsGroup'

export type TripChatMobileTabId = 'chat' | 'timeline' | 'list' | 'map'

export interface TripChatMobileTabItem {
  id: TripChatMobileTabId
  label: string
}

interface TripChatMobileTabsProps {
  activeTab: TripChatMobileTabId
  ariaLabel: string
  tabs: ReadonlyArray<TripChatMobileTabItem>
  onTabChange: (tabId: TripChatMobileTabId) => void
}

const SegmentedOptionsRegion = styled.div`
  display: flex;
  min-height: ${rem(56)};
  align-items: center;
  padding: ${rem(8)} ${rem(16)};
  border-bottom: 1px solid ${props => props.theme.palette.neutral.surface.lightForeground};
  background-color: ${props => props.theme.palette.neutral.surface.normalBackground};

  > * {
    width: 100%;
  }
`

function TripChatMobileTabs({ activeTab, ariaLabel, tabs, onTabChange }: TripChatMobileTabsProps) {
  const renderOption = useCallback((tab: TripChatMobileTabItem) => (
    <SegmentedOption
      key={tab.id}
      value={tab.id}
      title={tab.label}
      checked={activeTab === tab.id}
    />
  ), [activeTab])

  return (
    <SegmentedOptionsRegion role="group" aria-label={ariaLabel}>
      <SegmentedOptionsGroup<TripChatMobileTabId>
        inputsName="trip-chat-mobile-view"
        distribution="filled"
        onValueChange={onTabChange}
      >
        {tabs.map(renderOption)}
      </SegmentedOptionsGroup>
    </SegmentedOptionsRegion>
  )
}

export default TripChatMobileTabs
